export default __webpack_public_path__ + "static/media/nfl-bg.e8a737de.jpg";